module.exports = __webpack_public_path__ + "static/img/3@2x.7f8407e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home/3@2x.png
// module id = AN/n
// module chunks = 0